import NavbarCustom from "../../../Components/NavbarCustom";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useParent } from "../../../APIContext/ParentContext";
import "./style.css";
export default function Forget() {
  const [email, setEmail] = useState("");
  const navigate = useNavigate();
  const { forgotPassword } = useParent();

  const handleSubmit = async (e) => {
    e.preventDefault();

    console.log("Forgot password requested for email:", email);

    const result = await forgotPassword({ email });

    if (result.success) {
      localStorage.setItem("resetEmail", email);
      navigate("/otp-verify");
    }
  };

  return (
    <>
      <NavbarCustom />

      <div className="auth-wrapper brightness">
        <div className="auth-card brightness">
          <div className="card-box">
            <h2 className="auth-title text-clip">FORGOT PASSWORD</h2>

            <form
              className="auth-form"
              style={{ marginTop: "2rem" }}
              onSubmit={handleSubmit}
            >
              <label className="text-clip">Email Address *</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />

              <button className="auth-login-btn" type="submit">
                SEND OTP
              </button>
            </form>

            <hr className="auth-divider" />

            <button
              className="auth-create-btn"
              onClick={() => navigate("/login")}
            >
              <span className="text-clip">Back To Login</span>
            </button>
          </div>
        </div>
        <div className="auth-side-image"></div>
      </div>
    </>
  );
}
